





































































import Vue, { PropType } from 'vue'
import { EventItem } from '../../base/store/state.interface'
import MessagesWidgetEventItemMixin from '../../widget-board/widgets/messages-widget/MessagesWidgetEventItemMixin'
import MessagesWidgetMixins from '../../widget-board/widgets/messages-widget/MessagesWidgetMixins'

export default Vue.extend({
  mixins: [
    MessagesWidgetMixins,
    MessagesWidgetEventItemMixin
  ],
  props: {
    item: {
      type: Object as PropType<EventItem>,
      required: true,
      default: {}
    }
  },
  data() {
    return {
      // required for compatibility with MessagesWidgetMixins
      type: 'event'
    }
  }
})
